import { Component } from "@angular/core";

@Component({
  selector: "app-families-content",
  templateUrl: "families-content.component.html",
})
export class FamiliesContentComponent {}
